import { PxApiError } from './PxApiError';
import { LoggerTexts } from '../LoggerTexts';

export class ConfigJsonParserError extends PxApiError {
	_initialError?: Error;
	constructor(initialError?: Error, message?: string) {
		const formattedMessage = message ? message.trim() : '';
		/* istanbul ignore next */ //Coverage works correctly with ES6
		super(formattedMessage);

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, ConfigJsonParserError);
		}
		this.name = 'PxApi.ConfigJsonParserError';
		this._initialError = initialError;

		let messageText = LoggerTexts.CFG_JSON_PARSER.ERROR_HEADER;
		if (formattedMessage) {
			messageText += `: ${formattedMessage}`;
		}
		this.message = messageText;
	}
}
